export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SUBMIT_START = "SUBMIT_START";
export const SUBMIT_ERROR = "SUBMIT_ERROR";
export const SUBMIT_STOP = "SUBMIT_STOP";

export const showModal = (type, data) => {
    return {
        type: SHOW_MODAL,
        payload: {
            type,
            data,
        }
    };
};

export const hideModal = () => {
    return {
        type: HIDE_MODAL,
    };
};

export const submitStart = () => {
    return {
        type: SUBMIT_START,
    };
};

export const submitStop = () => {
    return {
        type: SUBMIT_STOP,
    };
};

